

/***
 * Formats value as an Australian phone number
 *
 * @param value
 * @returns {*}
 */
export default function ausPhone(value) {

    if (typeof(value) === 'undefined') {
        return value;
    }
    /***
     * ausPhone takes an australian phone number in E164 format
     * and returns a formatted version with the country code removed
     */
    if (value.startsWith('+61') && value.length === 12) {
        if (value.startsWith('+614')) {
            // Format as a mobile number
            // +61414600261 => 0414 600 261
            return '0' + value.substring(3, 6) + ' ' + value.substring(6, 9) + ' ' + value.substring(9)
        } else {
            // format as a land line
            // +61390181851 => 03 9018 8151
            return '0' + value.substring(3, 4) + ' ' + value.substring(4, 8) + ' ' + value.substring(8)
        }
    } else {
        // return as-is
        return value;
    }
}
